import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import ItemCard from 'screens/listingDetail/components/Faq/components/ItemCard';

import classes from './AlternativesCarousel.module.scss';

/* eslint-disable import/no-duplicates -- Swiper module CSS imports are side-effect imports. */
import 'swiper/css';
import 'swiper/css/pagination';
/* eslint-enable import/no-duplicates */

const AlternativesCarousel = ({ alternatives, eventProps }) => (
  <div className={classes.root}>
    <Swiper
      modules={[Pagination]}
      pagination={{
        clickable: true,
        el: '#kt-overview-alternatives-pagination',
      }}
      slidesPerView={1}
      slidesOffsetBefore={1}
      simulateTouch={false}
    >
      {alternatives.slice(0, 3).map((faq_contender, index) => (
        <SwiperSlide key={`overview-alternatives-${faq_contender.id}`}>
          <ItemCard
            listing={faq_contender}
            className={classes.itemCard}
            eventProps={eventProps}
            listingPosition={index}
          />
        </SwiperSlide>
      ))}
    </Swiper>
    <div
      id="kt-overview-alternatives-pagination"
      className={classes.pagination}
    />
  </div>
);

export default AlternativesCarousel;
